export default {
  euncet: {
    name: "euncet",
    basic: {
      default: "#CC1137",
      alternative: "#CC1137",
      fontAlternative: "#FFFFFF",
      darkMode: "#8cb7ef",
    },
    backgrounds: {
      menu: "#CC1137",
      body: "#FFFFFF",
    },
    button: {
      default: "#CC1137",
      font: "#FFFFFF",
      darkMode: "#8cb7ef",
    },
    soft_basic: {
      default: "#97999b",
      dark: "#9bb5d6",
    },
    text_black: {
      default: "#3B3B3B",
      darkMode: "#FFFFFF",
    },
    dark_black: {
      default: "#4a4a4a",
      darkMode: "#f3f3f3",
    },
    medium_black: {
      default: "#9b9b9b",
      dark: "#f4f4f4",
    },
    soft_black: {
      default: "#d8d8d8",
      dark: "#0c0c0c",
    },
    light_black: {
      default: "#F5F6F5",
      dark: "#3B3B3B",
    },
    white: {
      default: "#FFFFFF",
      darkMode: "#3B3B3B",
    },
    hasFavicon: true,
    logo: "/static/img/brands/euncet/logo.png",
    logocolor: "/static/img/brands/euncet/logo.svg",
    logodarkmode: "/static/img/brands/euncet/logo-white.svg",
    logoSize: "medium",
    logoLogin: "/static/img/brands/euncet/logo-white.png",
    background: "/static/img/brands/euncet/background-login.jpg",
    emailContacto: "careers.services@euncet.com",
    emailInscripcion: "careers.services@euncet.com",
    emailProblemas: "careers.services@euncet.com",
    emailJuridica: "practicas.derecho@euncet.edu",
    emailIngenieria: "practicas.ingenieria@euncet.edu",
    emailEconomica: "practicas.ade.ibs@euncet.edu",
    emailSanitaria: "practicas.soci.sani@euncet.edu",
    emailEducacion: "mvtorres@euncet.edu",
    emailRRII: "practicas.ri.com.ti@euncet.edu",
    emailInternacional: "jrmunoz@euncet.edu",
    hideSAML: true,
    ownpopup_info: {
      editar_personales: {
        titulo: "Edición de datos personales",
        texto:
          "Si alguno de los datos no editables no es correcto, por favor, accede a tu intranet para modificarlos.",
      },
    },
    footer: {
      es: {
        title: "Construimos un futuro juntos",
        contact: {
          title: "CONTACTO",
          email: "careers.services@euncet.com",
          phone: "93 730 16 07",
        },
        rrss: {
          title: "REDES SOCIALES",
          items: {
            linkedin: "https://www.linkedin.com/company/euncet/",
            twitter: "https://twitter.com/euncet",
            facebook: "https://www.facebook.com/euncet",
            instagram: "https://www.instagram.com/euncet",
            tiktok: "https://www.tiktok.com/@euncet.business.school",
            "youtube-play":
              "https://www.youtube.com/channel/UCmVyMfX0lzcvu0zZmQFq2xA",
          },
        },
        textos: [],
        links: {
          "Aviso Legal": "https://www.euncet.com/es/aviso-legal/",
          Privacidad: "/politica-de-privacidad",
          "Política de Cookies": "https://www.euncet.com/es/politica-cookies/",
          "Canal de denuncias": "https://www.euncet.com/es/canal-de-denuncias/",
          "www.euncet.com": "https://www.euncet.com/es/",
        },
      },
      ca: {
        title: "Construïm un futur junts",
        contact: {
          title: "CONTACTE",
          email: "careers.services@euncet.com",
          phone: "93 730 16 07",
        },
        rrss: {
          title: "XARXES SOCIALS",
          items: {
            linkedin: "https://www.linkedin.com/company/euncet/",
            twitter: "https://twitter.com/euncet",
            facebook: "https://www.facebook.com/euncet",
            instagram: "https://www.instagram.com/euncet",
            tiktok: "https://www.tiktok.com/@euncet.business.school",
            "youtube-play":
              "https://www.youtube.com/channel/UCmVyMfX0lzcvu0zZmQFq2xA",
          },
        },
        textos: [],
        links: {
          "Avís legal": "https://www.euncet.com/ca/avis-legal/",
          Privacidat: "/politica-de-privacidad",
          "Política de Cookies": "https://www.euncet.com/ca/politica-cookies/",
          "Canal de denúncies": "https://www.euncet.com/ca/canal-de-denuncies/",
          "www.euncet.com": "https://www.euncet.com/ca/",
        },
      },
      en: {
        title: "We build a future together",
        contact: {
          title: "CONTACT",
          email: "careers.services@euncet.com",
          phone: "93 730 16 07",
        },
        rrss: {
          title: "SOCIAL NETWORKS",
          items: {
            linkedin: "https://www.linkedin.com/company/euncet/",
            twitter: "https://twitter.com/euncet",
            facebook: "https://www.facebook.com/euncet",
            instagram: "https://www.instagram.com/euncet",
            tiktok: "https://www.tiktok.com/@euncet.business.school",
            "youtube-play":
              "https://www.youtube.com/channel/UCmVyMfX0lzcvu0zZmQFq2xA",
          },
        },
        textos: [],
        links: {
          "Legal notice": "https://www.euncet.com/en/legal-notice/",
          Privacy: "/privacy-policy",
          "Cookies Policy": "https://www.euncet.com/en/cookies-policy/",
          "Complaints channel": "https://www.euncet.com/en/complaints-channel/",
          "www.euncet.com": "https://www.euncet.com/en/",
        },
      },
    },
    fonts: {
      link: "family=Muli:300,400,500,700,800",
      principal: "'Muli', sans-serif",
      secundaria: "'Muli', sans-serif",
    },
    ownstyles: "/static/img/brands/euncet/style.css",
    logintexts: {
      es: {
        selectProfile: "Selecciona tu perfil:",
        antiguos: "Alumni",
        estudiantes: "Estudiantes",
        empresas: "Empresas",
      },
      ca: {
        selectProfile: "Selecciona el teu perfil:",
        antiguos: "Alumni",
        estudiantes: "Estudiants",
        empresas: "Empreses",
      },
      en: {
        selectProfile: "Select your profile:",
        antiguos: "Alumni",
        estudiantes: "Students",
        empresas: "Companies",
      },
    },

    //PROPUESTA DE PRACTICAS
    instruccionesPropuestaPracticas: "",
    showPropuestaPracticas: true,
    ocultarInfoAux: true,

    //SETEO DE LAS OFERTAS
    requestEmpresaDestino: true,
    CVRequired: true,
    inscripcionExterna: true,
    programasInformaticosNoPersonalizables: true,
    requestDatosTutorEnOferta: true,
    hideCamposTutor: ["cargo", "departamento"],
    showDireccionEmpresa: true,
    requestDatosFirmanteEnPropuesta: false,
    requestDatosFirmanteEnOferta: false,
    busquedaPuestoEmpresa: true,
    listBusquedaPractica: [
      "areaFuncional",
      "tiposFormacion",
      "titulaciones",
      "tituloPrograma",
      "tipoModalidadAsistencia",
    ],
    renunciaPracticasSET: false,
    notRequiredCamposTutor: true,
    notRequiredCamposTutorPropuesta: false,

    niveles: [
      {
        id: "grado",
        active: false,
        label: {
          es: "Grado",
          ca: "Grau",
        },
      },
      {
        id: "postgrado",
        active: false,
        label: {
          es: "Postgrado",
          ca: "Postgrau",
        },
      },
      {
        id: "doctorado",
        active: false,
        label: {
          es: "Doctorado",
          ca: "Doctorat",
        },
      },
    ],

    camposOferta: {
      otraRemuneracion: {
        label: {
          es: "Otra remuneración",
          en: "Other remuneration",
          ca: "Una altra remuneració"
        },
        showIn: ["Practicas", "Empleo"],
        required: false,
      },
      precioHora: {
        label: {
          es: "Remuneración(€/hora)",
          en: "Remuneration (€/hour)",
          ca: "Remuneració(€/hora)"
        },
        showIn: ["Practicas"],
      },
      horasPorSemana: {
        label: {
          es: "Horas semanales",
        },
        showIn: ["Practicas", "Empleo"],
      },
      areaFuncional: {
        label: "Área funcional",
        showIn: ["Practicas", "Empleo"],
        showrequired: true,
      },
      empresaDestino: {
        showIn: ["Empleo", "Practicas"],
      },
      descripcion: {
        label: {
          Empleo: {
            es: "Descripción del puesto*",
            en: "Job description*",
            ca: "Descripció del lloc*"
          },
          Practicas: {
            es: "Descripción del puesto*",
            en: "Job description*",
            ca: "Descripció del lloc*"
          },
        },
      },
      requisitos: {
        label: {
          Empleo: {
            es: "Requisitos del puesto",
            en: "Job Requirements",
            ca: "Requisits del lloc"
          },
          Practicas: {
            es: "Requisitos del puesto",
            en: "Job Requirements",
            ca: "Requisits del lloc"
          },
        },
      },
      experiencia: {
        showIn: ["Empleo"],
      },
      salario: {
        showIn: ["Empleo"],
      },
      modalidad: {
        showIn: ["Empleo", "Practicas"],
      },
      urlInformacionComplementaria: {
        showIn: ["Empleo", "Practicas"],
      },
    },

    camposPracticas: {
      puestoTrabajo: {
        label: "Puesto de trabajo",
        required: true,
      },
      tareasDesarrollar: {
        label: "Tareas a desarrollar",
        required: true,
      },
      datostutoruniversidad: {
        label: "Nombre y apellidos del tutor de la Universidad",
        required: true,
      },
      centropracticas: {
        label: "Centro de prácticas",
        required: false,
      },
      ayudaEstudio: {
        label: "Remuneración (€ brutos/mes)",
      },
      tutorEmpresa: {
        titulacion: true,
        dni: true,
        telefono: true,
      },
      practicaRemunerada: {
        label: {
          es: "Práctica remunerada",
        },
        showIn: ["Practicas"],
      },
      direccion: {
        label: "direccion",
      },
      tipoPracticaCurriExtracurri: true,
      solicitudParaCentroEducativo: false,
    },

    //REGISTRO DE LA EMPRESA
    requestStartUp: true,
    requestTipoEmpresa: true,
    requestDireccionFullContactoEmpresa: false,
    requestDireccionContactoEmpresa: false,
    requestidiomaComunicacionContacto: true,
    hideDniFirmante: false,
    registroEmpresas: {
      sede: {
        visible: false,
        required: false,
      },
      dni: {
        visible: true,
        required: true,
      },
    },

    //CV DEL CANDIDATO
    quitarCampoDiscapacidad: true,
    canEditPeriodoPracticas: true,
    sectoresInteres: true,
    checkIbanInPracticasConServicio: true,
    personales: {
      imagen: {
        visible: true,
        editable: true,
      },
      emailComunicaciones: {
        visible: true,
        editable: true,
      },
      email: {
        visible: true,
        editable: true,
      },
      fecha_nacimiento: {
        visible: true,
        editable: false,
      },
      telefono: {
        visible: true,
        editable: true,
      },
      movil: {
        visible: true,
        editable: true,
      },
      permisotrabajo: {
        visible: true,
        editable: true,
      },
      numeroSeguridadSocial: {
        visible: true,
        editable: true,
      },
      direcciones: {
        1: {
          visible: true,
          editable: true,
          hide: [],
        },
        2: {
          visible: true,
          editable: true,
          hide: [],
        },
      },
    },

    academicos: {
      calificacion: {
        editable: true,
      },
      centro: {
        editable: true,
      },
    },

    experiencia: {
      descripcion: {
        editable: true,
        validate: "required",
      },
      sector: {
        editable: true,
        validate: "required",
      },
      empresa: {
        editable: true,
        validate: "required",
      },
      provincia: {
        editable: true,
        validate: "required",
      },
      duracion: {
        editable: true,
        validate: "required",
      },
    },

    profesionales: {
      intercambio: {
        editable: false,
        visible: false,
      },
    },

    interes: {},

    //DOCUMENTACIÓN DE EMPRESAS
    haveDocumentosPracticas: true,
    canSubirConvenios: true,

    //REGISTRO DE LOS ALUMNOS

    infoAlumno: true,
  },
};


// WEBPACK FOOTER //
// ./src/brands/brands.js